import {
  ArrowBackRounded as ArrowBackRoundedIcon,
  CloseRounded as CloseRoundedIcon,
  MenuRounded as MenuRoundedIcon
} from '@mui/icons-material'
import { Drawer, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { t } from 'i18next'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { encodeInBase64Url, putIntoUrl } from '../../../helpers/utilis.js'
import DeviceDetails from '../../Devices/Details/DeviceDetail.jsx'
import FilteredPublicList from '../../Devices/List/FilteredPublicList.jsx'
import DevicesList from '../../Devices/List/List.jsx'
import FrontMap from '../../FrontMap/FrontMap.jsx'
import { useAuth } from '../../Shared/Contexts/AuthContext.jsx'
import { useGlobalContext } from '../../Shared/Contexts/GlobalContext.jsx'

const returnPage = {
  devicesList: '/management/devices',
  eventsList: '/management/events'
}

const FrontPage = () => {
  const { setCurrentOrganizationKey } = useAuth()
  const { deviceId, organizationKey } = useParams()
  const { returnTo } = Object.fromEntries(new URLSearchParams(window.location.search))
  const { devicesFilters: filters, resetMapPosition } = useGlobalContext()
  const navigate = useNavigate()

  const [selectedDeviceId, setSelectedDeviceId] = useState()

  const [isOpenDrawer, setIsOpenDrawer] = useState(true)

  const toggleDrawer = () => {
    setIsOpenDrawer(!isOpenDrawer)
  }

  const handleBackToList = (url = '/') => {
    resetMapPosition()
    navigate(url)
  }

  const handleDeviceSelected = ({ id }) => {
    setSelectedDeviceId(id)
  }

  useEffect(() => {
    setSelectedDeviceId(deviceId)
  }, [deviceId])

  useEffect(() => {
    const encoded = encodeInBase64Url(filters)
    const params = returnTo ? { filters: encoded, returnTo } : { filters: encoded }
    putIntoUrl(params)
  }, [filters])

  const drawerWidth = deviceId ? 820 : 580

  const Main = styled('main', {
    shouldForwardProp: (prop) => prop !== 'open'
  })(({ open, theme }) => ({
    marginTop: '66px',
    flexGrow: 1,
    padding: 0,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen
      }),
      marginLeft: 0
    })
  }))

  const renderPanel = () => {
    if (deviceId) {
      return (
        selectedDeviceId && (
          <DeviceDetails
            deviceId={selectedDeviceId}
            onDeviceSelected={handleDeviceSelected}
          />
        )
      )
    }
    if (organizationKey) {
      setCurrentOrganizationKey(organizationKey)
      return <FilteredPublicList />
    }

    return <DevicesList />
  }

  return (
    <>
      <Drawer
        sx={{ '& .MuiDrawer-paper': { width: drawerWidth } }}
        variant="persistent"
        anchor="left"
        open={isOpenDrawer}
      >
        {renderPanel()}
      </Drawer>
      <Main
        open={isOpenDrawer}
        sx={{ position: 'relative' }}
      >
        {deviceId ? (
          <IconButton
            variant="contained"
            aria-label={`${t('devices.closeList')}`}
            sx={{
              position: 'absolute',
              top: '10px',
              left: '10px',
              background: '#FFFFFF',
              zIndex: (theme) => theme.zIndex.drawer - 200,
              '&:hover': {
                transition: 'unset',
                background: '#FFFFFF'
              }
            }}
            onClick={() => handleBackToList(returnPage[returnTo])}
          >
            <ArrowBackRoundedIcon />
          </IconButton>
        ) : (
          <IconButton
            variant="contained"
            aria-label={t(isOpenDrawer ? 'devices.closeList' : 'devices.openList')}
            sx={{
              position: 'absolute',
              top: '10px',
              left: '10px',
              background: '#FFFFFF',
              zIndex: (theme) => theme.zIndex.drawer - 200,
              '&:hover': {
                transition: 'unset',
                background: '#FFFFFF'
              }
            }}
            onClick={toggleDrawer}
          >
            {isOpenDrawer ? <CloseRoundedIcon /> : <MenuRoundedIcon />}
          </IconButton>
        )}

        <FrontMap />
      </Main>
    </>
  )
}

export default FrontPage
